import React from 'react';
import classNames from 'classnames';
import Tag, { LinkTagProps } from './LinkTag';

interface LinkTagsProps {
  tags: Array<LinkTagProps>;
  className?: string;
}

const LinkTags: React.FC<LinkTagsProps> = ({ tags, className = '' }) => {
  const classes = classNames('LinkTags', className);
  return tags && (
    <div className={classes}>
      {tags.map((tag) => (
        <Tag key={tag.name} name={tag.name} url={tag.url} />
      ))}
    </div>
  );
};

export default LinkTags;
